module.exports = __webpack_public_path__ + "static/media/xiaomi.7b9e6584.png";